export default {
  header: {
    height: 40,
  },
  subheader: {
    height: 30,
  },
  rightDrawerModal: {
    leftSpace: 140,
    topSpace: 40,
    toolbarHeight: 60,
  },
};
